"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../style/variables");
var layout_1 = require("../layout");
var Text_1 = __importDefault(require("../Text/Text"));
var lodash_1 = require("lodash");
var input_1 = require("../input");
var react_2 = require("react");
var STRINGS = {
    GENERIC_MAINTENANCE_MESSAGE: "Maintenance currently in progress. Some\n  functionality maybe in unavailable.",
    LINK: 'Read more here.',
};
var styles = {
    message: react_1.css({
        background: "var(" + variables_1.RootColor.White + ")",
        borderBottom: "1px solid var(" + variables_1.BorderColor.GRAY_LIGHT_3 + ")",
    }),
};
var getMaintenanceInfo = function () {
    var _a, _b, _c;
    try {
        var maintenanceString = (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.process) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.MAINTENANCE_STATUS;
        var maintenanceInfo = JSON.parse(maintenanceString.replace(/&quot;/g, '"'));
        // ensure maintenance info has at least a message and app list
        if (!lodash_1.has(maintenanceInfo, 'message') || !lodash_1.has(maintenanceInfo, 'apps')) {
            throw new Error('Maintenance info seems to be malformed');
        }
        return maintenanceInfo;
    }
    catch (_d) {
        return undefined;
    }
};
var getMaintenanceInfoForApp = function (currentApp) {
    var maintenanceInfo = getMaintenanceInfo();
    // either not in maintenance or no currentApp was provided to TopBar
    if (!(maintenanceInfo && currentApp)) {
        return;
    }
    // in maintenance mode, but not for this app
    var noMaintenanceForThisApp = !maintenanceInfo.apps.includes(currentApp);
    if (noMaintenanceForThisApp) {
        return;
    }
    return maintenanceInfo;
};
var MaintenanceMessage = function (_a) {
    var currentApp = _a.currentApp;
    var maintenance = react_2.useMemo(function () { return getMaintenanceInfoForApp(currentApp); }, [currentApp]);
    if (!maintenance) {
        return null;
    }
    return (react_1.jsx(layout_1.Flex, { justifyContent: 'center', className: 'w100', gap: 10, css: styles.message, alignItems: 'center' },
        react_1.jsx(Text_1.default.Body, { size: 'sm', color: variables_1.TextColor.DEFAULT }, maintenance.message),
        maintenance.link && (react_1.jsx(input_1.Button, { hierarchy: 'link-primary', size: 'sm', onClick: function () { return window.open(maintenance.link, '_blank'); } },
            react_1.jsx(Text_1.default.Body, { size: 'sm', color: variables_1.TextColor.DEFAULT }, STRINGS.LINK)))));
};
exports.default = MaintenanceMessage;
